import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { BranchingConfig, Branch } from 'src/app/components/branching-editor/types';
import { FilterButtonComponent } from 'src/app/components/filter-button/filter-button.component';
import { FilterOption, SelectedFilterMap } from 'src/app/utils/filter-utils';

export const listAnimation = trigger('listAnimation', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-10px)' }),
    animate('100ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'translateY(0)' }),
    animate('100ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' })),
  ]),
]);

@Component({
  selector: 'app-branching-editor',
  templateUrl: './branching-editor.component.html',
  styleUrls: ['./branching-editor.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FilterButtonComponent, NgxTippyModule],
  animations: [listAnimation],
})
export class BranchingEditorComponent {
  @Input() config: BranchingConfig;
  @Input() filterOptions: FilterOption[];
  @Input() projectId: string;

  @Output() configChange = new EventEmitter<BranchingConfig>();
  @ContentChild('stepTemplate') stepTemplate: TemplateRef<any>;

  animationStep: any;

  branchFiltersDidChange(branch: Branch, filters: SelectedFilterMap) {
    branch.filters = filters;
    this.configChange.emit(this.config);
  }

  addBranch() {
    const newBranch = {
      filters: new Map(),
      content: {},
    };
    const lastIndex = this.config.branches.length;
    // Add a branch before the last branch, which should remain the fallback branch
    this.config.branches.splice(lastIndex - 1, 0, newBranch);
    this.configChange.emit(this.config);
  }

  removeBranch(index: number) {
    this.config.branches.splice(index, 1);
    this.configChange.emit(this.config);
  }
}
